import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { OpusJob, OpusJobsCriteria } from '../models';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { OpusJobsTableRowComponent } from './opus-jobs-table-row.component';
//import { Store } from '@ngrx/store';

@Component({
  selector: 'opus-jobs-table',
  templateUrl: './opus-jobs-table.component.html'
})
export class OpusJobsTableComponent {
  @Input() criteria: OpusJobsCriteria;
  @Input() opusJobs$: Observable<OpusJob[]>;
  @Input() isEditing: boolean;

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    console.log('OpusJobsTableComponent()...');

    this.form = this.fb.group({
      opusJobsData: this.fb.array([])
    });
  }

  ngOnInit() {
    console.log('OpusJobsTableComponent.ngOnInit()...');

    this.createForm();
  }

  ngOnDestroy(): void {}

  createForm() {
    const opusJobsData = this.fb.array([]);

    this.opusJobs$.forEach(i => {
      if (i != null) {
        for (let ind = 0; ind < i.length; ind++) {
          const itm = OpusJobsTableRowComponent.BuildItem(i[ind]);
          opusJobsData.push(itm);
        }
        this.form = this.fb.group({
          opusJobsData: opusJobsData
        });
      }
    });
  }

  getChanges(): FormGroup[] {
    const changed = (this.form.controls.opusJobsData as FormArray).controls.filter(g => g.dirty);

    console.log('OpusJobsTableComponent.getChanges(): ', changed);

    return changed as FormGroup[];
  }
}
